import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetQuotes(params = {}) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/quote",
        params,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetQuote(quoteId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/quote/" + quoteId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateQuote(data) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/quote",
        data,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateQuote(quoteId, data) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/quote/" + quoteId,
        data,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestApproveQuote(quoteId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/quote/" + quoteId + "/approve",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRejectQuote(quoteId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/quote/" + quoteId + "/reject",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAcceptQuote(quoteId, data) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/quote/" + quoteId + "/accept",
        data: data || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeclineQuote(quoteId, data) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/quote/" + quoteId + "/decline",
        data: data || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestReopenQuote(quoteId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/quote/" + quoteId + "/reopen",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCloneQuote(quoteId) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/quote/" + quoteId + "/clone",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestQuotePdf(quoteId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/quote/" + quoteId + "/pdf",
        responseType: "blob",
        withCredentials: true,
        crossorigin: true,
    });
}
